<!--
Author: TangChen
Date: 2018-10-25
Desc: 数字滚动加载组件
-->
<template>
    <div class="comp-num-grow comp">
        <span ref="numberGrow" :data-time="time" class="number-grow" :data-value="value">0</span>
    </div>
</template>
<script>
export default {
    props: {
        time: {
            type: Number,
            default: 2
        },
        value: {
            type: String,
            default: "5.321"
        }
    },
    watch: {
        value(val) {
            this.numberGrow(this.$refs.numberGrow);
        }
    },
    methods: {
        numberGrow(ele) {
            let _this = this;
            let step = (_this.value * 10) / (_this.time * 500);
            let current = 0;
            let start = 0;
            let t = setInterval(function () {
                start += step;
                if (start > _this.value) {
                    clearInterval(t);
                    start = _this.value;
                    t = null;
                }
                if (current === start) {
                    ele.innerHTML = _this.$util.fmtNum(current, 3);
                    return;
                }
                current = start;
                ele.innerHTML = _this.$util.fmtNum(current, 3);
            }, 10);
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.comp-num-grow {
    display: inline-block;
    .number-grow-warp {
        transform: translateZ(0);
    }
    .number-grow {
        font-family: Arial-BoldMT, sans-serif;
        color: #ffaf00;
        letter-spacing: 2.67px;
        display: block;
    }
}
</style>
